import aboutImg from "../assets/images/home-about-img.png";
import { Link } from "react-router-dom";

function HomeAbout() {
  return (
    <section id="actu-all-about">
      {/* Left Side Image */}
      <div className="actu-all-about-left">
        <img src={aboutImg} alt="About Actu-ALL Chemicals" />
      </div>

      {/* Right Side Text */}
      <div className="actu-all-about-right">
       <p>
          Actu-All Chemicals, headquartered in the Netherlands, is a leading
          producer and distributor of high-quality Analytical Standards and
          Solutions. With state-of-the-art production and warehousing facilities
          in Oss and Hoogeveen, we ensure precision, reliability, and
          consistency in every product. In addition to our proprietary
          formulations, we supply a comprehensive range of laboratory chemicals
          from our trusted partner brands. Our core expertise lies in the
          development and manufacturing of custom-made solutions tailored for
          specific analytical applications, supporting industries and research
          institutions in achieving the highest standards of accuracy and
          reproducibility.
        </p>
        

        
        <Link to="/about">
          <span>About Us</span>
        </Link>
      </div>
    </section>
  );
}

export default HomeAbout;
